import { ConfirmDialog } from "@scmlatam/web-ui";
import type { useUndoConfirm } from "../hooks/useUndoConfirm";

const UndoConfirm = (undoConfirmProps: ReturnType<typeof useUndoConfirm>) => {
  return (
    <>
      <ConfirmDialog
        open={undoConfirmProps.open}
        iconType="warning"
        title={undoConfirmProps.t("title")}
        message={undoConfirmProps.t("message")}
        confirmText={undoConfirmProps.t("buttons.undo")}
        cancelText={undoConfirmProps.t("buttons.cancel")}
        onClose={() => undoConfirmProps.setOpen(false)}
        onConfirm={() => undoConfirmProps.undoExecution()}
      />
    </>
  );
};

export { UndoConfirm };
